import React from "react";
import {useParams} from "react-router-dom";

import {faEdit, faSave} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

import {useUpdateWipLevelV2, useWipLevelV2} from "~/api/hooks/useWipLevelV2";
import CustomButton from "~/component/common/CustomButton";
import {useGameState} from "~/contexts/gamestate/useGameState";

const RenameButton: React.FC = () => {
  const {id} = useParams<{id: string}>();
  const {data: level} = useWipLevelV2({id});
  const {getAllInstances} = useGameState();

  const {mutate: updateWipLevel, isPending: savePending} =
    useUpdateWipLevelV2();

  const [isEditing, setIsEditing] = React.useState(false);
  const [newName, setNewName] = React.useState("");

  // Initialize with the current level name when it loads
  React.useEffect(() => {
    if (level) {
      setNewName(level.name || "");
    }
  }, [level]);

  if (isEditing) {
    return (
      <div className="flex items-center justify-between w-full bg-green-500 hover:bg-green-600 rounded transition">
        <input
          type="text"
          value={newName}
          onChange={(e) => setNewName(e.target.value)}
          className="flex-1 ml-1 p-1 rounded text-black focus:outline-none"
          placeholder="Name"
        />
        <CustomButton
          onClick={() => {
            if (!level || !id) return;
            updateWipLevel({
              key: {id},
              data: {
                ...level,
                name: newName,
                data: getAllInstances(),
              },
            });
            setIsEditing(false);
          }}
          className="p-2 ml-1"
          disabled={savePending}
        >
          <FontAwesomeIcon icon={faSave} size="lg" />
        </CustomButton>
      </div>
    );
  }

  return (
    <CustomButton
      onClick={() => setIsEditing(true)}
      className="flex items-center justify-center w-full py-2 bg-green-500 hover:bg-green-600 rounded transition"
    >
      <FontAwesomeIcon icon={faEdit} size="lg" className="mr-2" />
      Rename
    </CustomButton>
  );
};

export default RenameButton;
